import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-单井优化分析_钻井选型分析",
  "use": "icon-单井优化分析_钻井选型分析-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-单井优化分析_钻井选型分析\">\n<path d=\"M13.4,5.7l0-5.7H2.6v5.7L1,7.6L2.7,16l2.7-3L8,16l2.7-3l2.7,3L15,7.6L13.4,5.7z M12.3,1v4.7H3.6V1H12.3z M12.8,13.8\n\tl-2.1-2.4L8,14.5l-2.7-3.1l-2.1,2.4L2.1,7.9l1-1.2h9.8l1,1.2L12.8,13.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol